import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TopSection } from '../../ui/TopSection';
import { useTimeControls } from '../../../hooks/useTimeControls';
import UtilizationReport from '../reports/hub/UtilizationReport';

/**
 * Detailed waste page for the Cost Percent flow (/costpercent/waste). Reuses the
 * existing utilization (waste) report — graph + full table — under the standard
 * page shell with a back link to the Cost Percent page.
 */
const CostPercentWastePage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { dateRange, setDateRange, selectedTimeOption, setSelectedTimeOption } = useTimeControls();

  return (
    <div>
      <TopSection
        title={t('costPercent.waste.pageTitle')}
        description={t('costPercent.waste.pageDescription')}
        showMobileTitle
        backButton
        handleGoBack={() => navigate('/costpercent')}
        dateRange={dateRange}
        setDateRange={setDateRange}
        selectedTimeOption={selectedTimeOption}
        setSelectedTimeOption={setSelectedTimeOption}
      />
      <UtilizationReport />
    </div>
  );
};

export default CostPercentWastePage;
